<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <div class="mt-2">
        <b-button size="sm" class="mr-2">Take Picture</b-button>
        <b-button size="sm">Upload Picture</b-button>
      </div>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <picture-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedConditions.hidden
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'hidden',
              value: properties.hidden,
              defaultValue: '',
              form: this.form
            })
          : properties.hidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <div v-if="controlValue" class="picture-preview" style="height: 150px">
        <img height="150" :src="controlValue.picture" />
      </div>
      <div class="mt-2">
        <b-button v-if="isMobile" class="mr-2" @click="takePicture" size="sm">Take Picture</b-button>
        <b-button v-else class="mr-2" @click="showPictureTaker" size="sm"
          >Take Picture</b-button
        >        
        <input
          ref="filePicture"
          @change="previewPictureFile"
          type="file"
          style="display: none;"
          accept="image/*" 
          capture="camera"
        />
        <canvas ref="canvas" id="canvas" width="250" height="150"></canvas>
        
        <input
          ref="fileUpload"
          @change="previewFile"
          type="file"
          style="display: none;"
        />
        <b-button @click="uploadPicture" size="sm">Upload Picture</b-button>
      </div>
      <b-modal
        v-model="pictureTakerShown"
        title="Picture"
        @ok="savePicture"
        centered
        size="sm"
        no-close-on-backdrop
        header-bg-variant="primary"
        header-text-variant="white"
        header-class="bg-purple"
      >
        <template v-slot:modal-ok="{}">Take Picture</template>
        <template v-slot:modal-cancel="{}">Cancel</template>
        <div class="text-center">
          <video
            ref="video"
            id="video"
            width="250"
            height="150"
            autoplay
          ></video>
        </div>
      </b-modal>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      <div v-if="controlValue" class="picture-preview" style="height: 150px">
        <img :src="controlValue.picture" />
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { formatDate, formatDateTimeSql } from "../../../../helpers/date";
import { fileToBase64, resizeImage } from "../../../../helpers/file";
import PictureV1Properties from "./PictureV1Properties.vue";
import {isMobile} from "../../../../helpers/general"
export default {
  name: "PictureV1",
  components: { PictureV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],

  data() {
    return {
      pictureTakerShown: false,
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      file: null,
      isMobile: isMobile()
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.properties.value
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    showPictureTaker() {
      this.pictureTakerShown = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: { min: 250, ideal: 250, max: 250 },
              height: { min: 150, ideal: 150, max: 150 }
            }
          })
          .then(stream => {
            this.$refs.video.srcObject = stream;
            this.$refs.video.play();
          });
      }
    },
    uploadPicture() {
      this.$refs.fileUpload.click();
    },
    takePicture() {
      this.$refs.filePicture.click();
    },
    async previewPictureFile(event) {
      const file = event.srcElement.files[0];
      var self = this;
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function (e) {
          var myImage = new Image(); // Creates image object
          myImage.src = e.target.result; // Assigns converted image to image object
          myImage.onload = function() {
            var myContext = self.$refs.canvas.getContext("2d"); // Creates a contect object
            self.$refs.canvas.width = myImage.width; // Assigns image's width to canvas
            self.$refs.canvas.height = myImage.height; // Assigns image's height to canvas
            myContext.drawImage(myImage,0,0); // Draws the image on canvas
            self.$refs.canvas.toBlob(async function (blob) {
              const blobUrl = URL.createObjectURL(blob);
              const resizedBlob = await resizeImage(blobUrl, 1920, 1920);
              const base64 = await fileToBase64(resizedBlob);
              self.controlValue = {
                picture: base64,
                date: formatDateTimeSql(self.getCurrentAdjustedDateTime())
              };
            })
          }
        }
      }
    },
    async previewFile(event) {
      const file = event.srcElement.files[0];

      if (file) {
        const blobUrl = URL.createObjectURL(file);
        const blob = await resizeImage(blobUrl, 1920, 1920);
        const base64 = await fileToBase64(blob);
        this.controlValue = {
          picture: base64,
          date: formatDateTimeSql(this.getCurrentAdjustedDateTime())
        };
      }
    },
    formatDate(date) {
      return formatDate(date);
    },
    savePicture(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.canvas
        .getContext("2d")
        .drawImage(this.$refs.video, 0, 0, 250, 150);
      this.controlValue = {
        picture: this.$refs.canvas.toDataURL("image/png"),
        date: formatDateTimeSql(this.getCurrentAdjustedDateTime())
      };
      this.pictureTakerShown = false;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
        ${
          this.controlValue
            ? `
          <div class="picture-preview" style="height: 150px">
            <img style="max-width: 100%; max-height: 100%; width: auto; height: auto;" src="${this.controlValue.picture}" />
          </div>
        `
            : ""
        }
          
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
#canvas {
  display: none;
}
</style>
